"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTES = void 0;
exports.ROUTES = {
    ACCESS_DENIED: '/access-denied',
    AUTHORIZE: '/authorize',
    CMS: '/cms',
    CMS_COLLECTIONS: '/cms/collections',
    CMS_RELEASES: '/cms/releases',
    HOME: '/',
    KNOWLEDGE_BASE: '/knowledge-base',
    PAGE_GROUPS: '/cms/page-groups',
    PAGES: '/cms/pages',
    PAGE_NOT_FOUND: '/page-not-found',
    PROJECT_TIMELINES: '/project-timelines',
    PROMO_CODES: '/promo-codes',
    RULES: '/rules',
    VENDORS: '/vendors',
    VENDOR_CODES: '/vendors/vendor-codes',
    VENDOR_CODES_HOME_WARRANTY: '/vendors/vendor-codes-homewarranty',
    VENDOR_CODES_COMMERCIAL: '/vendors/vendor-codes/commercial',
    VENDOR_CODES_COMMERCIAL_HOME_WARRANTY: '/vendors/vendor-codes/commercial/home-warranty',
    VENDOR_CODES_DIRECT_MAIL: '/vendors/vendor-codes/direct-mail',
    VENDOR_CODES_INTERNET: '/vendors/vendor-codes/internet',
    VENDOR_CODES_INTERNET_HOME_WARRANTY: '/vendors/vendor-codes/internet/home-warranty',
};
